import React, { useContext, useCallback, useMemo, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import AdvancedSearchDropdown from '../../../components/dropdown';
import Global from '../../../../store/global-selectors';

import { AdvancedSearchShipmentContext } from '../../context';
import { id } from '../../../../filters/options/created-by';
import { isOperator } from '../../../../filters/operators/collection';
import messages from '../messages';

import baseStyle from '../../../style.module.less';

const defaultOption = {
  id: 'DEFAULT_OPTION',
  apiKey: 'DEFAULT_OPTION',
  component: <FormattedMessage {...messages.selectOne} />,
};

const CreatedByFilter = () => {
  const users = useSelector(Global.selectSellerUsers);
  const allOptions = useMemo(() => {
    const options = users.map((user) => ({
      id: user.userId,
      apiKey: user.userId,
      component: user.name,
    }));
    return [defaultOption, ...options];
  }, [users]);

  const { filters, updateFilter, clearFilter } = useContext(AdvancedSearchShipmentContext);

  const { value: [value = defaultOption.apiKey] = [] } = filters.find((filter) => filter.id === id) || {};
  const selectedUser = allOptions.find((opt) => opt.apiKey === value);

  useEffect(() => () => clearFilter(id), [clearFilter]);

  const onOptionSelected = useCallback(
    (option) => {
      if (option.id === defaultOption.id) {
        clearFilter(id);
        return;
      }
      updateFilter(id, [option.apiKey], isOperator);
    },
    [updateFilter, clearFilter],
  );

  return (
    <span className={baseStyle.filterInput}>
      <label className={baseStyle.filterLabel}>
        <FormattedMessage {...messages.createdBy} />
      </label>
      <AdvancedSearchDropdown onOptionSelected={onOptionSelected} options={allOptions} selectedId={selectedUser.id} />
    </span>
  );
};

export default CreatedByFilter;
